import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";

export interface RawAggregatedDeviceState {
  id: string;
  lastSeenByGatewayAt: string | undefined;
  lastSeenByBLEScannerAt: string | undefined;
  lastGPSFixAt: string | undefined;
  lastObservationPerDevice: {[key: string]: string};
  lastRssiPerDevice: {[key: string]: number};
  associatedDevices: {[key: string]: string};
  lastBatteryVoltageAt: string | undefined;
  batteryVoltage: number | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class AggregatedDeviceStateApiClient extends MoovementApiClient {

  getAggregatedDeviceStates(deviceIds: string[]): Observable<RawAggregatedDeviceState[]> {
    return this.httpClient.post<RawAggregatedDeviceState[]>(`${this.baseUrl}/api/device/state/aggregated/list`, deviceIds);
  }
}
